import ADMIN_PERMISSIONS from '@/constants/authorization/admin-permissions'

export default [
  {
    header: 'navigation.edit-dashboard',
  },
  {
    title: 'navigation.plans',
    route: 'super:plans',
    adminPermissions: [ADMIN_PERMISSIONS.PLANS],
    icon: 'TagIcon',
  },
  {
    title: 'navigation.business-types',
    route: 'super:business-types',
    adminPermissions: [ADMIN_PERMISSIONS.BUSINESS_TYPES],
    icon: 'ArchiveIcon',
  },
  {
    title: 'navigation.stickers',
    route: 'super:stickers',
    adminPermissions: [ADMIN_PERMISSIONS.STICKERS],
    icon: 'OctagonIcon',
  },
  {
    title: 'navigation.business-categories',
    route: 'super:business-categories',
    adminPermissions: [ADMIN_PERMISSIONS.BUSINESS_CATEGORIES],
    icon: 'CommandIcon',
  },
  {
    title: 'navigation.help',
    route: 'super:help',
    adminPermissions: [ADMIN_PERMISSIONS.HELP],
    icon: 'ApertureIcon',
  },
  {
    title: 'navigation.requests',
    route: 'super:requests',
    adminPermissions: [ADMIN_PERMISSIONS.CUSTOM_SOLUTIONS],
    icon: 'HelpCircleIcon',
  },
  {
    title: 'navigation.vendor-requests',
    route: 'super:vendor-requests',
    adminPermissions: [ADMIN_PERMISSIONS.PAYMENT],
    icon: 'HelpCircleIcon',
  },
  {
    title: 'announcement.announcements',
    route: 'super:announcements',
    adminPermissions: [ADMIN_PERMISSIONS.ANNOUNCEMENTS],
    icon: 'AlertTriangleIcon',
  },
]
